<script lang="typescript">
    import { state } from "./stores.js";
    import { getCurrency } from "./utils.ts";
    export let price;
    export let inline = false;
    export let addAsterix = false;
    const display = inline ? "inline whitespace-nowrap" : "";
</script>

{#if price === 0}
    <span class="inline text-2xl font-bold {display}">Included</span>
{:else}
    <div class="{display} w-2/5">
        <slot name="prefix" />
        <span class="inline text-2xl font-bold tracking-tighter -mr-0.5">
            {getCurrency($state)}
        </span>
        <h1 class="inline tracking-tight">
            {price}
            {#if addAsterix}<span class="inline -ml-1.5 font-normal">*</span>{/if}
        </h1>
    </div>
{/if}
